/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import {
  GrpcMessage,
  RecursivePartial,
  ToProtobufJSONOptions
} from '@ngx-grpc/common';
import { BinaryReader, BinaryWriter, ByteSource } from 'google-protobuf';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
export enum PortalNotificationGroup {
  PORTAL_NOTIFICATION_GROUP_UNSPECIFIED = 0,
  PORTAL_NOTIFICATION_GROUP_TRANSACTIONAL = 1
}
/**
 * Message implementation for portal_web_push.GetConfigRequest
 */
export class GetConfigRequest implements GrpcMessage {
  static id = 'portal_web_push.GetConfigRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetConfigRequest();
    GetConfigRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetConfigRequest) {}

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetConfigRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        default:
          _reader.skipField();
      }
    }

    GetConfigRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetConfigRequest,
    _writer: BinaryWriter
  ) {}

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetConfigRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetConfigRequest.AsObject>) {
    _value = _value || {};
    GetConfigRequest.refineValues(this);
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetConfigRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetConfigRequest.AsObject {
    return {};
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetConfigRequest.AsProtobufJSON {
    return {};
  }
}
export module GetConfigRequest {
  /**
   * Standard JavaScript object representation for GetConfigRequest
   */
  export interface AsObject {}

  /**
   * Protobuf JSON representation for GetConfigRequest
   */
  export interface AsProtobufJSON {}
}

/**
 * Message implementation for portal_web_push.GetConfigResponse
 */
export class GetConfigResponse implements GrpcMessage {
  static id = 'portal_web_push.GetConfigResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetConfigResponse();
    GetConfigResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetConfigResponse) {
    _instance.enabled = _instance.enabled || false;
    _instance.vapidPublicKey = _instance.vapidPublicKey || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetConfigResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.enabled = _reader.readBool();
          break;
        case 2:
          _instance.vapidPublicKey = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetConfigResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetConfigResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.enabled) {
      _writer.writeBool(1, _instance.enabled);
    }
    if (_instance.vapidPublicKey) {
      _writer.writeString(2, _instance.vapidPublicKey);
    }
  }

  private _enabled: boolean;
  private _vapidPublicKey: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetConfigResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetConfigResponse.AsObject>) {
    _value = _value || {};
    this.enabled = _value.enabled;
    this.vapidPublicKey = _value.vapidPublicKey;
    GetConfigResponse.refineValues(this);
  }
  get enabled(): boolean {
    return this._enabled;
  }
  set enabled(value: boolean) {
    this._enabled = value;
  }
  get vapidPublicKey(): string {
    return this._vapidPublicKey;
  }
  set vapidPublicKey(value: string) {
    this._vapidPublicKey = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetConfigResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetConfigResponse.AsObject {
    return {
      enabled: this.enabled,
      vapidPublicKey: this.vapidPublicKey
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetConfigResponse.AsProtobufJSON {
    return {
      enabled: this.enabled,
      vapidPublicKey: this.vapidPublicKey
    };
  }
}
export module GetConfigResponse {
  /**
   * Standard JavaScript object representation for GetConfigResponse
   */
  export interface AsObject {
    enabled: boolean;
    vapidPublicKey: string;
  }

  /**
   * Protobuf JSON representation for GetConfigResponse
   */
  export interface AsProtobufJSON {
    enabled: boolean;
    vapidPublicKey: string;
  }
}

/**
 * Message implementation for portal_web_push.RegisterSubscriptionRequest
 */
export class RegisterSubscriptionRequest implements GrpcMessage {
  static id = 'portal_web_push.RegisterSubscriptionRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RegisterSubscriptionRequest();
    RegisterSubscriptionRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RegisterSubscriptionRequest) {
    _instance.endpoint = _instance.endpoint || '';
    _instance.p256dh = _instance.p256dh || '';
    _instance.auth = _instance.auth || '';
    _instance.userAgent = _instance.userAgent || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RegisterSubscriptionRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.endpoint = _reader.readString();
          break;
        case 2:
          _instance.p256dh = _reader.readString();
          break;
        case 3:
          _instance.auth = _reader.readString();
          break;
        case 4:
          _instance.userAgent = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.userAgent,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    RegisterSubscriptionRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RegisterSubscriptionRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.endpoint) {
      _writer.writeString(1, _instance.endpoint);
    }
    if (_instance.p256dh) {
      _writer.writeString(2, _instance.p256dh);
    }
    if (_instance.auth) {
      _writer.writeString(3, _instance.auth);
    }
    if (_instance.userAgent) {
      _writer.writeMessage(
        4,
        _instance.userAgent as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _endpoint: string;
  private _p256dh: string;
  private _auth: string;
  private _userAgent?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RegisterSubscriptionRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<RegisterSubscriptionRequest.AsObject>) {
    _value = _value || {};
    this.endpoint = _value.endpoint;
    this.p256dh = _value.p256dh;
    this.auth = _value.auth;
    this.userAgent = _value.userAgent
      ? new googleProtobuf000.StringValue(_value.userAgent)
      : undefined;
    RegisterSubscriptionRequest.refineValues(this);
  }
  get endpoint(): string {
    return this._endpoint;
  }
  set endpoint(value: string) {
    this._endpoint = value;
  }
  get p256dh(): string {
    return this._p256dh;
  }
  set p256dh(value: string) {
    this._p256dh = value;
  }
  get auth(): string {
    return this._auth;
  }
  set auth(value: string) {
    this._auth = value;
  }
  get userAgent(): googleProtobuf000.StringValue | undefined {
    return this._userAgent;
  }
  set userAgent(value: googleProtobuf000.StringValue | undefined) {
    this._userAgent = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RegisterSubscriptionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RegisterSubscriptionRequest.AsObject {
    return {
      endpoint: this.endpoint,
      p256dh: this.p256dh,
      auth: this.auth,
      userAgent: this.userAgent ? this.userAgent.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RegisterSubscriptionRequest.AsProtobufJSON {
    return {
      endpoint: this.endpoint,
      p256dh: this.p256dh,
      auth: this.auth,
      userAgent: this.userAgent ? this.userAgent.toProtobufJSON(options) : null
    };
  }
}
export module RegisterSubscriptionRequest {
  /**
   * Standard JavaScript object representation for RegisterSubscriptionRequest
   */
  export interface AsObject {
    endpoint: string;
    p256dh: string;
    auth: string;
    userAgent?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for RegisterSubscriptionRequest
   */
  export interface AsProtobufJSON {
    endpoint: string;
    p256dh: string;
    auth: string;
    userAgent: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for portal_web_push.RegisterSubscriptionResponse
 */
export class RegisterSubscriptionResponse implements GrpcMessage {
  static id = 'portal_web_push.RegisterSubscriptionResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RegisterSubscriptionResponse();
    RegisterSubscriptionResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RegisterSubscriptionResponse) {
    _instance.subscriptionId = _instance.subscriptionId || '0';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RegisterSubscriptionResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.subscriptionId = _reader.readInt64String();
          break;
        default:
          _reader.skipField();
      }
    }

    RegisterSubscriptionResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RegisterSubscriptionResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.subscriptionId) {
      _writer.writeInt64String(1, _instance.subscriptionId);
    }
  }

  private _subscriptionId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RegisterSubscriptionResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<RegisterSubscriptionResponse.AsObject>
  ) {
    _value = _value || {};
    this.subscriptionId = _value.subscriptionId;
    RegisterSubscriptionResponse.refineValues(this);
  }
  get subscriptionId(): string {
    return this._subscriptionId;
  }
  set subscriptionId(value: string) {
    this._subscriptionId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RegisterSubscriptionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RegisterSubscriptionResponse.AsObject {
    return {
      subscriptionId: this.subscriptionId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RegisterSubscriptionResponse.AsProtobufJSON {
    return {
      subscriptionId: this.subscriptionId
    };
  }
}
export module RegisterSubscriptionResponse {
  /**
   * Standard JavaScript object representation for RegisterSubscriptionResponse
   */
  export interface AsObject {
    subscriptionId: string;
  }

  /**
   * Protobuf JSON representation for RegisterSubscriptionResponse
   */
  export interface AsProtobufJSON {
    subscriptionId: string;
  }
}

/**
 * Message implementation for portal_web_push.RemoveSubscriptionRequest
 */
export class RemoveSubscriptionRequest implements GrpcMessage {
  static id = 'portal_web_push.RemoveSubscriptionRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RemoveSubscriptionRequest();
    RemoveSubscriptionRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RemoveSubscriptionRequest) {
    _instance.endpoint = _instance.endpoint || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RemoveSubscriptionRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.endpoint = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    RemoveSubscriptionRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RemoveSubscriptionRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.endpoint) {
      _writer.writeString(1, _instance.endpoint);
    }
  }

  private _endpoint: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RemoveSubscriptionRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<RemoveSubscriptionRequest.AsObject>) {
    _value = _value || {};
    this.endpoint = _value.endpoint;
    RemoveSubscriptionRequest.refineValues(this);
  }
  get endpoint(): string {
    return this._endpoint;
  }
  set endpoint(value: string) {
    this._endpoint = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RemoveSubscriptionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RemoveSubscriptionRequest.AsObject {
    return {
      endpoint: this.endpoint
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RemoveSubscriptionRequest.AsProtobufJSON {
    return {
      endpoint: this.endpoint
    };
  }
}
export module RemoveSubscriptionRequest {
  /**
   * Standard JavaScript object representation for RemoveSubscriptionRequest
   */
  export interface AsObject {
    endpoint: string;
  }

  /**
   * Protobuf JSON representation for RemoveSubscriptionRequest
   */
  export interface AsProtobufJSON {
    endpoint: string;
  }
}

/**
 * Message implementation for portal_web_push.RemoveSubscriptionResponse
 */
export class RemoveSubscriptionResponse implements GrpcMessage {
  static id = 'portal_web_push.RemoveSubscriptionResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new RemoveSubscriptionResponse();
    RemoveSubscriptionResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: RemoveSubscriptionResponse) {
    _instance.removed = _instance.removed || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: RemoveSubscriptionResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.removed = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    RemoveSubscriptionResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: RemoveSubscriptionResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.removed) {
      _writer.writeBool(1, _instance.removed);
    }
  }

  private _removed: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of RemoveSubscriptionResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<RemoveSubscriptionResponse.AsObject>) {
    _value = _value || {};
    this.removed = _value.removed;
    RemoveSubscriptionResponse.refineValues(this);
  }
  get removed(): boolean {
    return this._removed;
  }
  set removed(value: boolean) {
    this._removed = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    RemoveSubscriptionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): RemoveSubscriptionResponse.AsObject {
    return {
      removed: this.removed
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): RemoveSubscriptionResponse.AsProtobufJSON {
    return {
      removed: this.removed
    };
  }
}
export module RemoveSubscriptionResponse {
  /**
   * Standard JavaScript object representation for RemoveSubscriptionResponse
   */
  export interface AsObject {
    removed: boolean;
  }

  /**
   * Protobuf JSON representation for RemoveSubscriptionResponse
   */
  export interface AsProtobufJSON {
    removed: boolean;
  }
}

/**
 * Message implementation for portal_web_push.GetPreferencesRequest
 */
export class GetPreferencesRequest implements GrpcMessage {
  static id = 'portal_web_push.GetPreferencesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPreferencesRequest();
    GetPreferencesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPreferencesRequest) {}

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPreferencesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        default:
          _reader.skipField();
      }
    }

    GetPreferencesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPreferencesRequest,
    _writer: BinaryWriter
  ) {}

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPreferencesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPreferencesRequest.AsObject>) {
    _value = _value || {};
    GetPreferencesRequest.refineValues(this);
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPreferencesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPreferencesRequest.AsObject {
    return {};
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPreferencesRequest.AsProtobufJSON {
    return {};
  }
}
export module GetPreferencesRequest {
  /**
   * Standard JavaScript object representation for GetPreferencesRequest
   */
  export interface AsObject {}

  /**
   * Protobuf JSON representation for GetPreferencesRequest
   */
  export interface AsProtobufJSON {}
}

/**
 * Message implementation for portal_web_push.PortalNotificationGroupPreference
 */
export class PortalNotificationGroupPreference implements GrpcMessage {
  static id = 'portal_web_push.PortalNotificationGroupPreference';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PortalNotificationGroupPreference();
    PortalNotificationGroupPreference.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PortalNotificationGroupPreference) {
    _instance.group = _instance.group || 0;
    _instance.displayName = _instance.displayName || '';
    _instance.description = _instance.description || '';
    _instance.enabled = _instance.enabled || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PortalNotificationGroupPreference,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.group = _reader.readEnum();
          break;
        case 2:
          _instance.displayName = _reader.readString();
          break;
        case 3:
          _instance.description = _reader.readString();
          break;
        case 4:
          _instance.enabled = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    PortalNotificationGroupPreference.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PortalNotificationGroupPreference,
    _writer: BinaryWriter
  ) {
    if (_instance.group) {
      _writer.writeEnum(1, _instance.group);
    }
    if (_instance.displayName) {
      _writer.writeString(2, _instance.displayName);
    }
    if (_instance.description) {
      _writer.writeString(3, _instance.description);
    }
    if (_instance.enabled) {
      _writer.writeBool(4, _instance.enabled);
    }
  }

  private _group: PortalNotificationGroup;
  private _displayName: string;
  private _description: string;
  private _enabled: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PortalNotificationGroupPreference to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<PortalNotificationGroupPreference.AsObject>
  ) {
    _value = _value || {};
    this.group = _value.group;
    this.displayName = _value.displayName;
    this.description = _value.description;
    this.enabled = _value.enabled;
    PortalNotificationGroupPreference.refineValues(this);
  }
  get group(): PortalNotificationGroup {
    return this._group;
  }
  set group(value: PortalNotificationGroup) {
    this._group = value;
  }
  get displayName(): string {
    return this._displayName;
  }
  set displayName(value: string) {
    this._displayName = value;
  }
  get description(): string {
    return this._description;
  }
  set description(value: string) {
    this._description = value;
  }
  get enabled(): boolean {
    return this._enabled;
  }
  set enabled(value: boolean) {
    this._enabled = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PortalNotificationGroupPreference.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PortalNotificationGroupPreference.AsObject {
    return {
      group: this.group,
      displayName: this.displayName,
      description: this.description,
      enabled: this.enabled
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PortalNotificationGroupPreference.AsProtobufJSON {
    return {
      group:
        PortalNotificationGroup[
          this.group === null || this.group === undefined ? 0 : this.group
        ],
      displayName: this.displayName,
      description: this.description,
      enabled: this.enabled
    };
  }
}
export module PortalNotificationGroupPreference {
  /**
   * Standard JavaScript object representation for PortalNotificationGroupPreference
   */
  export interface AsObject {
    group: PortalNotificationGroup;
    displayName: string;
    description: string;
    enabled: boolean;
  }

  /**
   * Protobuf JSON representation for PortalNotificationGroupPreference
   */
  export interface AsProtobufJSON {
    group: string;
    displayName: string;
    description: string;
    enabled: boolean;
  }
}

/**
 * Message implementation for portal_web_push.GetPreferencesResponse
 */
export class GetPreferencesResponse implements GrpcMessage {
  static id = 'portal_web_push.GetPreferencesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPreferencesResponse();
    GetPreferencesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPreferencesResponse) {
    _instance.groups = _instance.groups || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPreferencesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PortalNotificationGroupPreference();
          _reader.readMessage(
            messageInitializer1,
            PortalNotificationGroupPreference.deserializeBinaryFromReader
          );
          (_instance.groups = _instance.groups || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    GetPreferencesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPreferencesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.groups && _instance.groups.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.groups as any,
        PortalNotificationGroupPreference.serializeBinaryToWriter
      );
    }
  }

  private _groups?: PortalNotificationGroupPreference[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPreferencesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPreferencesResponse.AsObject>) {
    _value = _value || {};
    this.groups = (_value.groups || []).map(
      m => new PortalNotificationGroupPreference(m)
    );
    GetPreferencesResponse.refineValues(this);
  }
  get groups(): PortalNotificationGroupPreference[] | undefined {
    return this._groups;
  }
  set groups(value: PortalNotificationGroupPreference[] | undefined) {
    this._groups = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPreferencesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPreferencesResponse.AsObject {
    return {
      groups: (this.groups || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPreferencesResponse.AsProtobufJSON {
    return {
      groups: (this.groups || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module GetPreferencesResponse {
  /**
   * Standard JavaScript object representation for GetPreferencesResponse
   */
  export interface AsObject {
    groups?: PortalNotificationGroupPreference.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetPreferencesResponse
   */
  export interface AsProtobufJSON {
    groups: PortalNotificationGroupPreference.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for portal_web_push.SavePreferencesRequest
 */
export class SavePreferencesRequest implements GrpcMessage {
  static id = 'portal_web_push.SavePreferencesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SavePreferencesRequest();
    SavePreferencesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SavePreferencesRequest) {
    _instance.items = _instance.items || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SavePreferencesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new SavePreferencesRequest.Item();
          _reader.readMessage(
            messageInitializer1,
            SavePreferencesRequest.Item.deserializeBinaryFromReader
          );
          (_instance.items = _instance.items || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    SavePreferencesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SavePreferencesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.items && _instance.items.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.items as any,
        SavePreferencesRequest.Item.serializeBinaryToWriter
      );
    }
  }

  private _items?: SavePreferencesRequest.Item[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SavePreferencesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SavePreferencesRequest.AsObject>) {
    _value = _value || {};
    this.items = (_value.items || []).map(
      m => new SavePreferencesRequest.Item(m)
    );
    SavePreferencesRequest.refineValues(this);
  }
  get items(): SavePreferencesRequest.Item[] | undefined {
    return this._items;
  }
  set items(value: SavePreferencesRequest.Item[] | undefined) {
    this._items = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SavePreferencesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SavePreferencesRequest.AsObject {
    return {
      items: (this.items || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SavePreferencesRequest.AsProtobufJSON {
    return {
      items: (this.items || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module SavePreferencesRequest {
  /**
   * Standard JavaScript object representation for SavePreferencesRequest
   */
  export interface AsObject {
    items?: SavePreferencesRequest.Item.AsObject[];
  }

  /**
   * Protobuf JSON representation for SavePreferencesRequest
   */
  export interface AsProtobufJSON {
    items: SavePreferencesRequest.Item.AsProtobufJSON[] | null;
  }

  /**
   * Message implementation for portal_web_push.SavePreferencesRequest.Item
   */
  export class Item implements GrpcMessage {
    static id = 'portal_web_push.SavePreferencesRequest.Item';

    /**
     * Deserialize binary data to message
     * @param instance message instance
     */
    static deserializeBinary(bytes: ByteSource) {
      const instance = new Item();
      Item.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
      return instance;
    }

    /**
     * Check all the properties and set default protobuf values if necessary
     * @param _instance message instance
     */
    static refineValues(_instance: Item) {
      _instance.group = _instance.group || 0;
      _instance.enabled = _instance.enabled || false;
    }

    /**
     * Deserializes / reads binary message into message instance using provided binary reader
     * @param _instance message instance
     * @param _reader binary reader instance
     */
    static deserializeBinaryFromReader(_instance: Item, _reader: BinaryReader) {
      while (_reader.nextField()) {
        if (_reader.isEndGroup()) break;

        switch (_reader.getFieldNumber()) {
          case 1:
            _instance.group = _reader.readEnum();
            break;
          case 2:
            _instance.enabled = _reader.readBool();
            break;
          default:
            _reader.skipField();
        }
      }

      Item.refineValues(_instance);
    }

    /**
     * Serializes a message to binary format using provided binary reader
     * @param _instance message instance
     * @param _writer binary writer instance
     */
    static serializeBinaryToWriter(_instance: Item, _writer: BinaryWriter) {
      if (_instance.group) {
        _writer.writeEnum(1, _instance.group);
      }
      if (_instance.enabled) {
        _writer.writeBool(2, _instance.enabled);
      }
    }

    private _group: PortalNotificationGroup;
    private _enabled: boolean;

    /**
     * Message constructor. Initializes the properties and applies default Protobuf values if necessary
     * @param _value initial values object or instance of Item to deeply clone from
     */
    constructor(_value?: RecursivePartial<Item.AsObject>) {
      _value = _value || {};
      this.group = _value.group;
      this.enabled = _value.enabled;
      Item.refineValues(this);
    }
    get group(): PortalNotificationGroup {
      return this._group;
    }
    set group(value: PortalNotificationGroup) {
      this._group = value;
    }
    get enabled(): boolean {
      return this._enabled;
    }
    set enabled(value: boolean) {
      this._enabled = value;
    }

    /**
     * Serialize message to binary data
     * @param instance message instance
     */
    serializeBinary() {
      const writer = new BinaryWriter();
      Item.serializeBinaryToWriter(this, writer);
      return writer.getResultBuffer();
    }

    /**
     * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
     */
    toObject(): Item.AsObject {
      return {
        group: this.group,
        enabled: this.enabled
      };
    }

    /**
     * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
     * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
     * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
     */
    toProtobufJSON(
      // @ts-ignore
      options?: ToProtobufJSONOptions
    ): Item.AsProtobufJSON {
      return {
        group:
          PortalNotificationGroup[
            this.group === null || this.group === undefined ? 0 : this.group
          ],
        enabled: this.enabled
      };
    }
  }
  export module Item {
    /**
     * Standard JavaScript object representation for Item
     */
    export interface AsObject {
      group: PortalNotificationGroup;
      enabled: boolean;
    }

    /**
     * Protobuf JSON representation for Item
     */
    export interface AsProtobufJSON {
      group: string;
      enabled: boolean;
    }
  }
}

/**
 * Message implementation for portal_web_push.SavePreferencesResponse
 */
export class SavePreferencesResponse implements GrpcMessage {
  static id = 'portal_web_push.SavePreferencesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SavePreferencesResponse();
    SavePreferencesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SavePreferencesResponse) {
    _instance.groups = _instance.groups || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SavePreferencesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PortalNotificationGroupPreference();
          _reader.readMessage(
            messageInitializer1,
            PortalNotificationGroupPreference.deserializeBinaryFromReader
          );
          (_instance.groups = _instance.groups || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    SavePreferencesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SavePreferencesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.groups && _instance.groups.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.groups as any,
        PortalNotificationGroupPreference.serializeBinaryToWriter
      );
    }
  }

  private _groups?: PortalNotificationGroupPreference[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SavePreferencesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<SavePreferencesResponse.AsObject>) {
    _value = _value || {};
    this.groups = (_value.groups || []).map(
      m => new PortalNotificationGroupPreference(m)
    );
    SavePreferencesResponse.refineValues(this);
  }
  get groups(): PortalNotificationGroupPreference[] | undefined {
    return this._groups;
  }
  set groups(value: PortalNotificationGroupPreference[] | undefined) {
    this._groups = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SavePreferencesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SavePreferencesResponse.AsObject {
    return {
      groups: (this.groups || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SavePreferencesResponse.AsProtobufJSON {
    return {
      groups: (this.groups || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module SavePreferencesResponse {
  /**
   * Standard JavaScript object representation for SavePreferencesResponse
   */
  export interface AsObject {
    groups?: PortalNotificationGroupPreference.AsObject[];
  }

  /**
   * Protobuf JSON representation for SavePreferencesResponse
   */
  export interface AsProtobufJSON {
    groups: PortalNotificationGroupPreference.AsProtobufJSON[] | null;
  }
}
